var _path, _rect, _rect2, _rect3, _path2, _polygon, _path3, _rect4, _circle, _circle2, _path4, _rect5, _polygon2, _path5, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCleanInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    "data-imageid": "clean-inbox-6",
    imageName: "New Message",
    className: "illustrations_image",
    style: {
      width: 200
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.39,129.39S29.62,252.83,158,254.56s187.08-17.22,187.66-80S300,53.11,219.41,52.46,95.24,75.43,78.39,129.39Z",
    fill: "#e6e6e6",
    opacity: 0.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 170.1,
    y: 70.89,
    width: 77.25,
    height: 116.56,
    transform: "translate(29.92 -39) rotate(11.49)",
    fill: "#c1c1c1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 171.59,
    y: 63.56,
    width: 77.25,
    height: 116.56,
    transform: "translate(28.49 -39.44) rotate(11.49)",
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 178.87,
    y: 72.46,
    width: 65.66,
    height: 84.19,
    transform: "translate(27.07 -39.89) rotate(11.49)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.65,124s-18.94,6.23-14.18,17.8c2.58,6.27,11.28,8.86,18.72,9.91a7.58,7.58,0,0,0,7.69-11.16,28.1,28.1,0,0,0-7.8-9.27Z",
    fill: "#f4a28c"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "218.53 274.83 218.53 217.64 275.72 212.53 285.94 274.83 218.53 274.83",
    fill: "#00288f",
    className: "target-color"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M207.91,188.48l14.2,20v8.87l50-4.47-2.53-24.37s6.12-29-1.54-47.95A66.53,66.53,0,0,1,263.63,113c.37-8.65-12-10.63-14.28-2.26-.94,3.54-1.59,10.74-1.52,18a21,21,0,0,1-1.88,8.87c-3,6.75-8.16,20-5.1,27.42L235,194Z",
    fill: "#f4a28c"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 118.72,
    y: 52.45,
    width: 106.23,
    height: 79.57,
    fill: "#24285b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 201.59,
    cy: 167.02,
    r: 5.9,
    fill: "#fff",
    opacity: 0.42
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 221.84,
    cy: 53.3,
    r: 14.82,
    fill: "#ffd200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M218.58,47.06A5.07,5.07,0,0,1,221.94,46a5.52,5.52,0,0,1,2.43.49,3.49,3.49,0,0,1,2,3.26,3.35,3.35,0,0,1-.63,2.07A3.06,3.06,0,0,1,224.27,53V53A3.24,3.24,0,0,1,226,54.29a3.87,3.87,0,0,1,.63,2.29,4.1,4.1,0,0,1-.53,2.08,3.61,3.61,0,0,1-1.58,1.43,6.3,6.3,0,0,1-6.08-.59A4.15,4.15,0,0,1,217,56.23h2.65a2.08,2.08,0,0,0,.65,1.53,2.37,2.37,0,0,0,1.68.57,2,2,0,0,0,1.53-.55,2,2,0,0,0,.54-1.43,1.87,1.87,0,0,0-.74-1.67,4.12,4.12,0,0,0-2.3-.51h-.56V51.93H221c1.84,0,2.76-.61,2.76-1.85a1.7,1.7,0,0,0-.49-1.3,2,2,0,0,0-1.43-.47,1.91,1.91,0,0,0-1.41.5,2,2,0,0,0-.58,1.25h-2.66A3.94,3.94,0,0,1,218.58,47.06Z",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 139.59,
    y: 69.38,
    width: 64.51,
    height: 44.09,
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "139.59 69.38 171.84 100.36 204.1 69.38 139.59 69.38",
    fill: "#ffd200"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.76,139H214.7v-7H156S153.22,135.16,153.76,139Z",
    opacity: 0.09
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "234.96 193.98 240.02 215.72 222.11 217.32 222.11 208.45 207.91 188.48 234.96 193.98",
    opacity: 0.09
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanInbox);
export default __webpack_public_path__ + "static/media/clean-inbox.cd6f90f53369ab2c9a5617a1e89c812d.svg";
export { ForwardRef as ReactComponent };